module.exports = __webpack_public_path__ + "media/IBMPlexSans-Regular.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/IBMPlexSans/IBMPlexSans-Regular.ttf
// module id = 1475
// module chunks = 58